<template>
  <AppAddBookingButton>

    <template slot="CaseAndAmount" slot-scope="props">
      <v-flex xs12 align-center justify-space-between>
        <v-select
          :items="props.casesList"
          v-model="props.selectedCase.id"
          label="Select case"
        ></v-select>
      </v-flex>

    </template>

    <template slot="ItemsSelection" slot-scope="props">
      <!-- <v-flex md6 align-center justify-space-between>
        <v-btn-toggle mandatory v-model="props.selectedItemType.id">
          <v-btn flat :value="serviceTypeID">Service</v-btn>
          <v-btn flat :value="inventoryTypeID">Inventory</v-btn>
        </v-btn-toggle>
      </v-flex>

      <v-flex md6 align-center justify-space-between>
        <v-select
          v-if="props.selectedItemType.id == inventoryTypeID"
          :items="props.inventoriesList"
          v-model="props.selectedInventory.id"
          label="Select inventory"
        ></v-select>

        <v-select
          v-else-if="props.selectedItemType.id == serviceTypeID"
          :items="props.servicesList"
          v-model="props.selectedService.id"
          label="Select service"
        ></v-select> -->

        <v-flex md12>
          <v-select
            :items="props.servicesList"
            v-model="props.selectedService.id"
            label="Select whom to book"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
          </v-select>
        </v-flex>

<!--
        <v-flex md12 align-center justify-space-between>
          <v-text-field
            v-model="props.amount.number"
            type="number"
            label="Amount"
          ></v-text-field>
        </v-flex>
      </v-flex> -->
    </template>

  </AppAddBookingButton>
</template>

<script>
  import AppAddBookingButton from '@/components/AppAddBookingButton'
  import itemTypesMixins from '@/mixins/ItemTypes'

  export default {
    components: { AppAddBookingButton },
    mixins: [ itemTypesMixins ]
  }
</script>



// WEBPACK FOOTER //
// AddBookingButton.vue?4dd2f49a